document.addEventListener("nav:open", function() {
  document.body.classList.add("h-full", "overflow-hidden")
})

document.addEventListener("nav:close", function() {
  document.body.classList.remove("h-full", "overflow-hidden")
})
